import React, { useEffect, useState } from "react";
import axios from "../../axiosInstace";
import { useNavigate } from "react-router-dom";
import "./Vacancies.scss";

const ApprovedVacancies = () => {
  const [vacancies, setVacancies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_HR_URL}/recruitment/vacancies/approved`)
      .then((res) => setVacancies(res.data.data || []))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading)
    return <div className="vacancy-loader">Loading approved vacancies...</div>;

  const linkedVacancies = vacancies.filter((v) => !!v.jobPostId).length;
  const budgetCount = vacancies.filter((v) => !!v.budget).length;

  return (
    <div className="vacancy-page">
      <div className="vacancy-page__header">
        <div className="vacancy-page__header-main">
          <div className="vacancy-page__title-wrap">
            <h2 className="vacancy-page__title">Approved Vacancies</h2>
            <span className="vacancy-page__count">{vacancies.length} approved</span>
          </div>
          <p className="vacancy-page__sub">
            Create job posts from approved requests and monitor readiness
          </p>
        </div>
      </div>

      <div className="vacancy-stats-row vacancy-stats-row--compact">
        <div className="vacancy-stat" style={{ "--accent": "#0f6e56" }}>
          <div className="vacancy-stat__icon">✅</div>
          <div className="vacancy-stat__body">
            <p className="vacancy-stat__label">Approved</p>
            <p className="vacancy-stat__value">{vacancies.length}</p>
          </div>
          <div className="vacancy-stat__bar" />
        </div>
        <div className="vacancy-stat" style={{ "--accent": "#6d28d9" }}>
          <div className="vacancy-stat__icon">🔗</div>
          <div className="vacancy-stat__body">
            <p className="vacancy-stat__label">Already Linked</p>
            <p className="vacancy-stat__value">{linkedVacancies}</p>
          </div>
          <div className="vacancy-stat__bar" />
        </div>
        <div className="vacancy-stat" style={{ "--accent": "#d97706" }}>
          <div className="vacancy-stat__icon">₹</div>
          <div className="vacancy-stat__body">
            <p className="vacancy-stat__label">Budgeted</p>
            <p className="vacancy-stat__value">{budgetCount}</p>
          </div>
          <div className="vacancy-stat__bar" />
        </div>
      </div>

      {vacancies.length === 0 ? (
        <div className="vacancy-empty">No approved vacancies yet.</div>
      ) : (
        <div className="vacancy-table-wrapper">
          <table className="vacancy-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Job Title</th>
                <th>Department</th>
                <th>Role</th>
                <th>Positions</th>
                <th>Budget</th>
                <th>Closing Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {vacancies.map((v, i) => (
                <tr key={v.vacancyId}>
                  <td className="vacancy-table__index">{i + 1}</td>
                  <td>
                    <div className="vacancy-table__title">{v.jobTitle}</div>
                    <div className="vacancy-table__meta">#{v.vacancyId}</div>
                  </td>
                  <td>{v.departmentName}</td>
                  <td>{v.roleName}</td>
                  <td>{v.noOfVacancy}</td>
                  <td>₹{v.budget?.toLocaleString()}</td>
                  <td>{v.expectedClosingTime?.split("T")[0]}</td>
                  <td>
                    {/* Navigate to create job post with this vacancy pre-selected */}
                    <button
                      className="av-action-btn av-action-btn--job-post"
                      onClick={() =>
                        navigate("/recruitment/job-posts/create", {
                          state: { vacancyId: v.vacancyId, vacancy: v },
                        })
                      }
                    >
                      Create Job Post
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ApprovedVacancies;
